jQuery(document).ready(function($) {

    window.currentQuestion = $('#quiz-form .fieldset-wrap:first-child');
  
    $(window).resize(function() {
       if(this.resizeTO) clearTimeout(this.resizeTO);
       this.resizeTO = setTimeout(function() {
         $(this).trigger('resizeEnd');
       }, 500);
     });
  
    var $selectedAnswers = [];
    $('#quiz-form input[type="radio"]').change(function() {
      $(this).closest('fieldset').addClass('option-selected');
        $('.option-selected').next().addClass("show-nav");
      $selectedAnswers = [];
      $('#quiz-form input[type="radio"]:checked').each(function() {
          console.log ($selectedAnswers.push($(this)));
        
      });
  
      var nextField = $(window.currentQuestion).next('.fieldset-wrap');
      window.currentQuestion = nextField;
      if (window.currentQuestion[0] === undefined) {
        if ($(window).width() > 768) {
          $('#calcQuiz').click();
        }
      }
      else {
        var nextPos = $(window.currentQuestion).position().top;
        var topMargin = ( 608 - $(window.currentQuestion).height() ) / 2;
        if ($(window).width() > 768) {
          //$(".quiz-form-body").animate({ scrollTop: $('.quiz-form-body').scrollTop() + nextPos - topMargin }, 1000);
        }
        else {
          // do nothing
        }
      }
    });
  
    $('#quiz-form').bind('formreset.zf.abide', function(e) {
      window.currentQuestion = $('#quiz-form .fieldset-wrap:first-child');
      $('.quiz-results *[data-result-product-id]').each(function() {
        $(this).addClass('hide');
      })
      $('.quiz-data').html('');
      $('.quiz-stats').empty();
  
      $('fieldset').removeClass('option-selected');
  
      //$("html, body, .quiz-form-body").animate({ scrollTop: 0 }, 1000);
  
      /*if ($(window).width() > 768) {
        $('.quiz-results').removeClass('show').css('z-index', '1');
        $('#quiz-form').fadeIn(500);
      }*/
    });
    
    // Reset quiz on pageload still not clearing quiz values
    $( document ).ready(function() {
      $("input:radio[name='answer-0']").each(function(i) {this.checked = false;
});
      $('fieldset').removeClass('option-selected');

    });
    
    
  
    $('#quiz-form').submit(function(e) {
      e.preventDefault();
    });
    
    
    
    
  
    $('#quiz-form').bind("formvalid.zf.abide", function(e,target) {
      var $selectedProducts = [];
      // Get Product Tally
      $('#quiz-form input[type="radio"]:checked').each(function() {
        var recProds = $(this).attr('data-products').split(' ');
        for(var i = 0; i < recProds.length; i++) {
          if(!(recProds[i] in $selectedProducts)) {
            $selectedProducts[recProds[i]] = 1;
            console.log ('complete');
           // $('.quiz-title').addClass('hide');
          } else {
            console.log ($selectedProducts[recProds[i]]++);
          }
        }
      });
            
  
      var topProdID = 0, topProdQty = 0;
      for(const rec_prod in $selectedProducts) {
          
        if($selectedProducts[rec_prod] > topProdQty) {
          topProdID = rec_prod;
          topProdQty = $selectedProducts[rec_prod];
            console.log('topProdID = ' + topProdID);
        }
          
      }
  
      var textAnswers = [];
      $($selectedAnswers).each(function(index, element) {
        var questionID = $(element[0]).attr('data-question');
        var question = $('#question-' + questionID).html();
        var answer = $(element[0]).siblings('.answer').html();
  
        textAnswers.push({
          question: question,
          answer: answer,
        });
      });
  
      var quizAnswers = textAnswers;
      var resultName = $('.quiz-results *[data-result-product-id="'+topProdID+'"]').attr('data-result-product-name');
  
      /*$.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        datatype: "html",
          data: {'action': 'quiz_sending_mail', 'quizAnswers': quizAnswers, 'quizResult': resultName},
        success: function(response) {
        },error:function(response){
            console.log("error: " + response);
        }
      });*/
        
        
  
      $('.quiz-results *[data-result-product-id="'+topProdID+'"]').removeClass('hide');
  
      //if ($(window).width() > 768) {
        $('#quiz-form').fadeOut(500);
        $('.quiz-results').css('z-index', '3').addClass('show');
            
           
            

        //$('.brew-cover').addClass('slide-in-top');
        var controller = new ScrollMagic.Controller();
        if ($('.quiz-results').length > 0) {
          var tl = new gsap.timeline();
      
          tl.to($('.cover-ingredients-wrap .left-ingredient'), {duration: 200, transformOrigin: "50%, 50%", y: "-200px", ease: "slow(0.7, 0.7, false)"});
          tl.to($('.cover-ingredients-wrap .right-ingredient'), {duration: 200, transformOrigin: "50%, 50%", y: "-200px", ease: "slow(0.7, 0.7, false)"}, "-=200");
      
          new ScrollMagic.Scene({
          duration: "250%",
          })
          .setTween(tl)
          .addTo(controller);
        }
     // }
      /* else {
        var offset = $('.quiz-results').offset();
        var pos = offset.top;
        $("html, body").animate({ scrollTop: pos - 170 }, 500);
      } */
  
    });
    
    
  
    
    
    
  
    /* $('.retake-quiz').click(function() {
      $('#calcQuizReset').click();
    }); */
  
     /*window.fbAsyncInit = function() {
      FB.init({
        //appId            : '2656955637963501',
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v6.0'
      });
  
      $('.quiz-fb-btn').click(function() {
        var id = $(this).attr('data-product-id');
        FB.ui({
          method: 'share',
          href: window.location.protocol + '//' + window.location.host + window.location.pathname + '?quizreferral=' + id,
        }, function(response){});
      });
    }; */
    


    

    $('.quiz-slider').slick({
		slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        mobileFirst: true,
        arrows: false,
		
	});

    $('button.next').click(function(){
        $(".quiz-slider").slick('slickNext');
    });
    $('button.prev').click(function(){
        $(".quiz-slider").slick('slickPrev');
    });

    
    $(this).on('afterChange', function(event, slick, currentSlide){
        if (slick.$slides.length == currentSlide + slick.options.slidesToScroll) {
            //alert ('text should change');
            $( '.quiz-slider .next' ).text( 'SUBMIT' );
        } else {
            $( '.quiz-slider .next' ).text( 'NEXT' );
        }
    });


  });
  